import { Page } from 'layouts/Page';
import { FC } from 'react';
import { EudrFiles } from 'components/EudrService/EudrFiles';

export const EudrFilesPage: FC = () => {
	return (
		<Page title="EUDR Files – EAS Dashboard">
			<EudrFiles />
		</Page>
	);
};
